import { HubAuthProvider, useHubAuth } from "@/context/HubAuthContext";
import HubLogin from "@/pages/hub/HubLogin";
import HubDashboard from "@/pages/hub/HubDashboard";
import { Loader2 } from "lucide-react";

function HubContent() {
  const { hubUser, hubLoading } = useHubAuth();
  if (hubLoading) return <div className="min-h-screen bg-[#0f1117] flex items-center justify-center"><Loader2 className="w-8 h-8 text-white/30 animate-spin" /></div>;
  if (!hubUser || hubUser === false) return <HubLogin />;
  return <HubDashboard />;
}

export default function HubLayout() {
  return (
    <HubAuthProvider>
      <HubContent />
    </HubAuthProvider>
  );
}
